import { createAppVariants } from '@codeleap/styles'

const appVariants = createAppVariants({})

export type AppVariants = typeof appVariants
